import { Icon } from "@iconify/react";
import React from "react";

const Nojob = ({ message }) => {
  return (
    <div className="text-center mt-5">
      <Icon
        icon={"gg:work-alt"}
        color="#387ed8"
        style={{ marginRight: 10, marginTop: 80 }}
        fontSize={130}
      />
      <h6>{message || " Currently No Jobs We're curating new opportunities for you. Please check back soon!"}</h6>
    </div>
  );
};

export default Nojob;
